// extracted by mini-css-extract-plugin
export var discard = "_1r-4";
export var muiTooltipTooltip = "_1r-6";
export var notificationBar = "_1r-3";
export var notificationContainer = "_1r-2";
export var saveButtonHoverSlotWrapper = "_1r-5";
export var show = "_1r-1";
export var spacer = "_1r-0";